import { startGame3 } from '../../../api/game';
import { useCurrentUser } from '../../../redux/selectors/authSelectors';
import StageTitle from '../../../static/png//Stage_title.png';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  MainButton as _Button,
  CommonBG,
} from '@riddler-co-jp/specc-ui-components';
import { Mission } from '@riddler-co-jp/specc-ui-components';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

interface StartPageProps {
  onBack?: () => void;
}

const StartPage: React.FC<StartPageProps> = props => {
  const navigate = useNavigate();
  const goTo = (url: string) => {
    navigate(url);
  };
  const { eventId } = useParams<'eventId'>();
  const user = useCurrentUser();
  const onBack = React.useCallback(() => {
    location.href =
      'https://specc-dev.riddler.co.jp/events/' + eventId + '/stages';
  }, [eventId]);

  return (
    <CommonBG>
      <Rule>
        <Title src={StageTitle} />
        <Mission>
          制限時間以内にできるだけ多くの
          <br />
          ナゾを解きなさい。
        </Mission>
        <Time>
          <FontAwesomeIcon icon={faStopwatch} />
          制限時間 8分
        </Time>
        <VideoWrapper>
          <video controls>
            <source
              src={
                'https://storage.googleapis.com/specc-ct-movie/1-1Switch_%E3%83%AB%E3%83%BC%E3%83%AB%E8%AA%AC%E6%98%8E.mp4'
              }
              type='video/mp4'
            />
            <p>Your browser doesn't support HTML5 video.</p>
          </video>
        </VideoWrapper>
        <Description>
          <h2>ルール</h2>
          <ul>
            <li>
              画面に表示されるナゾを解いて、？にあてはまる言葉を推測しましょう。
            </li>
            <li>
              10秒ごとに、ナゾに関する手がかりが開示されます。手がかりは3つまであります。ひらめくための参考にしましょう。
            </li>
            <li>
              40秒経過すると、今の<b>ナゾをスキップすることができます。</b>
              スキップしたナゾは、元に戻って解き直すことはできません。
            </li>
            <li>
              <b>正解数に応じて得点が与えられます。</b>
              手がかりを見たり、答えを間違えたとしても、特にペナルティ等はありません。
            </li>
          </ul>
        </Description>
        <Buttons>
          <Button color='negative' size='large' onClick={() => onBack()}>
            戻る
          </Button>
          <Button
            color='positive'
            size='large'
            disabled={eventId === undefined || user?.uid == null}
            onClick={() => {
              if (eventId === undefined || user?.uid == null) return;
              startGame3(eventId, user.uid);
              goTo(`/events/${eventId}/countdown`);
            }}
          >
            スタート
          </Button>
        </Buttons>
      </Rule>
    </CommonBG>
  );
};

const RuleThumb = styled.img`
  width: 100%;
  height: auto;
`;

const Time = styled.div`
  background: rgba(206, 212, 218, 0.25);
  font-size: 1.8rem;
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 12px;
  margin-top: -1rem;

  svg {
    margin-right: 4px;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  margin: 1rem auto;
  border: solid 2px #6c7680;

  video {
    width: 100%;
    margin-bottom: -4px;
  }
`;

const Title = styled.img`
  display: block;
  height: 80px;
  width: auto;
  margin: 4rem auto 0;
`;

const Button = styled(_Button).attrs({
  variant: 'main',
})`
  max-width: 47%;
  margin: 0 1rem;

  &:last-child {
    margin-right: 0;
  }
`;

const Buttons = styled.div`
  height: 6rem;
  display: flex;
  justify-content: center;
  margin: 0 auto 10rem;
  margin-top: 2rem;
`;

const Rule = styled.div`
  max-width: 800px;
  margin: 6rem auto;
  margin-top: 0;
  display: block;
`;

const Description = styled.div`
  padding: 2rem;
  font-size: 1.6rem;

  ul {
    margin-left: 2rem;
  }

  li {
    margin-bottom: 1.4rem;
  }

  b {
    border-bottom: 1px solid black;
  }

  h2 {
    font-size: 2.8rem;
    margin-bottom: 1rem;
  }
`;

export default StartPage;
